import Mediator from '../mediator.min.js';

const platform = require('../components/platform.js');

// Some 3rd parties requires jQuery object in window object that's why it's here
window.$ = jQuery;
window.jQuery = jQuery;

// init of global variables DR and DCG which are referenced throughout the whole application
window.DR = window.DR || {};
window.DCG = window.DCG || {};

window.DR.pubsub = new Mediator();
window.DCG.pubsub = window.DR.pubsub;

// init of global variables App which is referenced throughout the whole application
window.App = {
  Platform: platform
};
